export const BenefitCard = ({ icon: Icon, title, body, testId }) => (
  <div className="card-soft p-8 flex gap-4" data-testid={testId}>
    <div
      className="shrink-0 w-12 h-12 rounded-xl bg-[#F4F9FF] text-[#1677C8] inline-flex items-center justify-center"
      aria-hidden="true"
    >
      <Icon size={22} strokeWidth={2.5} />
    </div>
    <div>
      <h3 className="font-display font-semibold text-lg text-[#14324A]">{title}</h3>
      <p className="mt-2 text-sm text-[#4B6B86] leading-relaxed">{body}</p>
    </div>
  </div>
);

export default BenefitCard;
